import React from "react";
import { BusinessCard } from "../";
import { Pagination } from "../../Data";
import { ErrorState } from "../../States";

const BusinessList = ({
  businesses = [],
  pagination = {},
  isLoading = false,
  error = null,
  onPageChange,
  currentPage = 1,
}) => {
  // Loading state
  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {Array.from({ length: 8 }).map((_, index) => (
            <div
              key={index}
              className="animate-pulse rounded-lg border border-gray-800 bg-gray-900 p-4"
            >
              <div className="mb-3 h-32 w-full rounded-lg bg-gray-800"></div>
              <div className="space-y-2">
                <div className="flex items-start space-x-3">
                  <div className="h-12 w-12 rounded-lg bg-gray-800"></div>
                  <div className="flex-1 space-y-1">
                    <div className="h-4 w-3/4 rounded bg-gray-800"></div>
                    <div className="h-3 w-1/2 rounded bg-gray-800"></div>
                  </div>
                </div>
                <div className="h-3 w-1/3 rounded bg-gray-800"></div>
                <div className="grid grid-cols-2 gap-2">
                  <div className="h-3 rounded bg-gray-800"></div>
                  <div className="h-3 rounded bg-gray-800"></div>
                </div>
                <div className="flex justify-between">
                  <div className="h-3 w-1/4 rounded bg-gray-800"></div>
                  <div className="h-3 w-1/4 rounded bg-gray-800"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <ErrorState
        title="Failed to load businesses"
        message={
          error.message ||
          "Something went wrong while loading businesses. Please try again."
        }
        onRetry={() => window.location.reload()}
      />
    );
  }

  // Empty state
  if (!businesses || businesses.length === 0) {
    return (
      <div className="py-12 text-center">
        <div className="mx-auto mb-4 flex h-24 w-24 items-center justify-center rounded-full bg-gray-800">
          <svg
            className="h-12 w-12 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        </div>
        <h3 className="mb-2 text-lg font-medium text-white">
          No businesses found
        </h3>
        <p className="mb-4 text-gray-400">
          No businesses match your current filters. Try adjusting your search
          criteria.
        </p>
      </div>
    );
  }

  const totalPages = pagination.total_pages || 1;
  const totalItems = pagination.total || 0;
  const from = pagination.from || 0;
  const to = pagination.to || 0;

  return (
    <div className="space-y-6">
      {/* Business Grid */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {businesses.map((business) => (
          <BusinessCard key={business.id} business={business} />
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="rounded-lg border border-gray-800 bg-gray-900 p-4">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            {/* Pagination Info */}
            <div className="text-sm text-gray-400">
              Showing <span className="font-medium text-white">{from}</span> to{" "}
              <span className="font-medium text-white">{to}</span> of{" "}
              <span className="font-medium text-white">{totalItems}</span>{" "}
              results
            </div>

            {/* Pagination Controls */}
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
              showPageNumbers={true}
              maxVisiblePages={5}
              showFirstLast={true}
              showPrevNext={true}
              disabled={isLoading}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BusinessList;
